<template>
	<v-row>
		<v-col class="mx-auto" cols="12" md="10" lg="9">
			<v-card outlined>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title class="umivale-headline mb-1">Identificación</v-list-item-title>
						<v-list-item-subtitle style="white-space: inherit;">Proporcione algunos datos del expediente
							para iniciar este trámite
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-card-text>
					<v-row>
						<v-col class="mx-auto" cols="12" sm="11" md="11">
							<v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%" />

							<v-form v-if="!isLoading" ref="validateForm" style="min-height: 150px">
								<v-row>
									<v-col cols="12" sm="4" md="4">
										<v-text-field outlined v-model="solicitud.dni" autocomplete="off"
											:rules="[validationRules.required, validationRules.dni]"
											label="DNI o NIE" />
									</v-col>

									<v-col cols="12" sm="4" md="4">
										<v-text-field outlined v-model="unmaskedNASS" v-mask="'##/########/##'"
											autocomplete="off" :rules="[validationRules.required, validationRules.nass]"
											label="NAF (Número de afiliación de la TGSS)"
											hint="Si su NAF tiene 7 dígitos, añada uno al inicio." persistent-hint />
										<div class="pl-3">
											<span>Ejemplo: 11/01234567/22
											</span><br>
											<span><a href="https://umivaleactiva.es/preguntas/faqs/-D-nde-puedo-encontrar-mi-NAF-"
													target="_blank" @click.stop>¿Dónde puedo encontrar mi NAF?</a>
											</span>
										</div>
									</v-col>

									<v-col cols="12" sm="4" md="4">
										<v-text-field outlined v-model="solicitud.expediente" autocomplete="off"
											@keyup="uppercase" class="upper-case" :rules="[validationRules.required]"
											label="Código de expediente" />
										<div class="ml-3">
											<span>Identifique cuál es el formato de su expediente e
												introdúzcalo completo, con puntos y barras.
											</span>
											<ul class="text-posibilidades"><span>Hay dos posibilidades:</span>
												<li class=" pt-1 ml-7"><span>CAEX.2020.12345</span></li>
												<li class="ml-7">
													<span>1/1/2020/12345/1</span>
												</li>
											</ul>
										</div>
									</v-col>
								</v-row>

								<v-row justify="center" class="pb-8">
									<v-btn class="btn-next" :disabled="isLoading" @click="validate" color="primary">
										Acceder
									</v-btn>
								</v-row>

							</v-form>
						</v-col>
					</v-row>
				</v-card-text>

				<v-row>
					<v-col v-if="!isLoading && mostrarAviso" class="mx-auto" cols="11">
						<v-alert color="#D92727" text>
							<img alt="warning" src="../assets/warning_rojo.svg" height="30px"
								style="margin: 10px 25px 0 10px; float: left;" />
							<span style="color: #595959; font-size: 1em; padding-left: 72px; display: block;"><strong>No
									encontramos ningún expediente asociado a los datos introducidos</strong><br>
								Por favor, asegúrese de que son correctos.<br>Si son correctos, contacte en el 900 365
								012 con nuestro servicio de atención al cliente.</span>
						</v-alert>
					</v-col>
				</v-row>

				<v-row>
					<v-col v-if="!isLoading && mostrarAvisoExpedienteNoAccesible" class="mx-auto" cols="11">
						<v-alert color="#D92727" text>
							<img alt="warning" src="../assets/warning_rojo.svg" height="30px"
								style="margin: 0px 25px 0 10px; float: left;" />
							<span
								style="color: #595959; font-size: 1em; padding-top: 2px; padding-left: 72px; display: block;">{{
									errorText }}
								<a href="tel:900365012">900 365 012</a></span>
						</v-alert>
					</v-col>
				</v-row>

				<v-row>
					<v-col class="mx-auto" cols="12">
						<CanalesAccesoDialog ref='dlgCanalesAcceso'
							@alert-event="event => $emit('alert-event', event)" />
					</v-col>
				</v-row>

			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import api from '@Base/services/solicitudService'
import apiAuditoria from '@Base/services/auditoriaService'
import { mask } from 'vue-the-mask'
import StepBase from './common/StepBase.js'
import CanalesAccesoDialog from './CanalesAccesoDialog'

export default {
	name: 'ComprobarSolicitud',
	mixins: [StepBase],
	components: {
		CanalesAccesoDialog
	},
	directives: { mask },
	data() {
		return {
			isLoading: false,
			mostrarAviso: false,
			mostrarAvisoExpedienteNoAccesible: false,
			unmaskedNASS: '',
			solicitud: {
				dni: '',
				nass: '',
				expediente: '',
			},
			movilesContacto: [],
			errorText: 'Los datos introducidos son correctos, pero no es posible subsanar este expediente. Puede preguntar los motivos a su persona de contacto en la mutua o llamar al '
		}
	},
	methods: {
		validate() {
			if (!this.$refs.validateForm.validate()) {
				return;
			}

			this.solicitud.dni = this.solicitud.dni.toUpperCase();
			this.solicitud.nass = this.unmaskedNASS.replace(/[^0-9]/g, '');
			this.solicitud.expediente = this.solicitud.expediente.toUpperCase();
			this.isLoading = true;
			this.mostrarAviso = false;
			this.mostrarAvisoExpedienteNoAccesible = false;

			api.comprobarSolicitud(this.solicitud,
				res => {
					this.isLoading = false;
					this.mostrarAviso = !res;

					if (res) {
						this.$store.commit('solicitud/setTokenGestion', res.tokenGestion);
						this.getEstadoRevision(res);
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al comprobar la solicitud', color: 'red' });
					console.log(error);
				});
		},
		uppercase() {
			this.solicitud.expediente = this.solicitud.expediente.toUpperCase();
		},
		getEstadoRevision(solicitante) {
			this.isLoading = true;

			apiAuditoria.getEstadoRevision(
				res => {
					this.$store.commit('solicitud/setTokenGestion', null);

					if (!res) {
						// comprobamos si la prestación es de tipo CATA DANA 
						api.comprobarCataDana(this.solicitud,
							resTipoCataDana => {
								if (resTipoCataDana) {
									if (resTipoCataDana == 'S') {
										this.getMovilesContacto(solicitante);
									} else if (resTipoCataDana == 'N') {
										if (res.estadoRevision < 3 || res.estadoRevision == 8) {
											this.mostrarAvisoExpedienteNoAccesible = true;
											this.isLoading = false;
											return;
										}
										this.getMovilesContacto(solicitante);
									}
								}
							},
							error => {
								this.isLoading = false;
								this.$emit('alert-event', { text: 'Error al comprobar si solicitud es CATA DANA', color: 'red' });
								console.log(error);
							});
					} else {
						if (res.estadoRevision < 3 || res.estadoRevision == 8) {
							this.mostrarAvisoExpedienteNoAccesible = true;
							this.isLoading = false;
							return;
						}
						this.getMovilesContacto(solicitante);
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener el estado de la revisión', color: 'red' });
					console.log(error);
				}
			);
		},
		getMovilesContacto(solicitante) {
			this.movilesContacto = [];

			apiAuditoria.getMovilesContacto(solicitante.tokenGestion,
				res => {
					this.isLoading = false;
					this.movilesContacto = res;
					this.$refs.dlgCanalesAcceso.open(solicitante, res);
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener los móviles de contacto', color: 'red' });
					console.log(error);
				});
		},
	},
	computed: {
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		$route(to) {
			this.mostrarAviso = false;
			this.$store.commit('solicitud/setTituloModulo', 'Prestación extraordinaria por cese de actividad');
			this.$store.commit('solicitud/setPasoActual', 1);
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.mostrarAviso = false;
			vm.$store.commit('solicitud/setTituloModulo', 'Prestación extraordinaria por cese de actividad');
			vm.$store.commit('solicitud/setPasoActual', 1);
		})
	}
}
</script>
<style scoped>
.text-posibilidades {
	padding-top: 1px;
	padding-left: 0px;
	line-height: 19.2px;
}

.upper-case input {
	text-transform: uppercase;
}
</style>
